/* MANA Landing Page - Interactive JS */
(function() {
  'use strict';

  /* ===== GALLERY ===== */
  window.lpChangeImg = function(thumb, src) {
    document.querySelectorAll('.lp-colostrum .hero-thumb').forEach(function(t) { t.classList.remove('active'); });
    thumb.classList.add('active');
    document.querySelector('#lpMainImg img').src = src;
  };

  window.lpGalleryNav = function(dir) {
    var thumbs = Array.from(document.querySelectorAll('.lp-colostrum .hero-thumb'));
    var activeIdx = thumbs.findIndex(function(t) { return t.classList.contains('active'); });
    var next = activeIdx + dir;
    if (next < 0) next = thumbs.length - 1;
    if (next >= thumbs.length) next = 0;
    thumbs[next].click();
  };

  /* ===== HERO REVIEW CAROUSEL ===== */
  var reviewIdx = 0;
  window.lpShowReview = function(idx) {
    reviewIdx = idx;
    var chips = document.querySelectorAll('#lpHeroReviews .hero-review-chip');
    var dots = document.querySelectorAll('#lpHeroReviewDots .hero-reviews-dot');
    chips.forEach(function(c, i) { c.classList.toggle('active', i === idx); });
    dots.forEach(function(d, i) { d.classList.toggle('active', i === idx); });
  };
  // Auto-rotate every 5s
  var reviewTotal = 0;
  function initReviewRotation() {
    reviewTotal = document.querySelectorAll('#lpHeroReviews .hero-review-chip').length;
    if (reviewTotal > 0) {
      setInterval(function() { reviewIdx = (reviewIdx + 1) % reviewTotal; lpShowReview(reviewIdx); }, 5000);
    }
  }

  /* ===== QTY SELECTOR ===== */
  window.lpSelectQty = function(el) {
    document.querySelectorAll('.lp-colostrum .qty-option').forEach(function(o) { o.classList.remove('selected'); });
    el.classList.add('selected');
    // Update sticky bar
    var label = el.querySelector('.qty-label');
    var price = el.querySelector('.qty-price');
    var stickyName = document.querySelector('.lp-colostrum .sticky-cta-name');
    var stickyPrice = document.querySelector('.lp-colostrum .sticky-cta-price');
    if (stickyName && label) stickyName.textContent = label.textContent;
    if (stickyPrice && price) stickyPrice.textContent = price.textContent;
  };

  /* ===== ADD TO CART (UpCart + Barn2) ===== */
  window.lpAddToCart = function() {
    var selected = document.querySelector('.lp-colostrum .qty-option.selected');
    if (!selected) return;

    var quantity = selected.dataset.quantity;
    var variantId = selected.dataset.variantId;
    var productId = selected.dataset.productId;
    var barn2Dcn = selected.dataset.barn2Dcn;
    var btn = document.querySelector('.lp-colostrum .hero-cta-btn');

    if (btn) {
      btn.classList.add('loading');
      btn.setAttribute('aria-disabled', 'true');
    }

    var payload = {
      items: [{
        form_type: 'product',
        utf8: '\u2713',
        id: variantId,
        'product-id': productId,
        quantity: quantity,
        properties: { '_barn2_dcn': barn2Dcn }
      }]
    };

    fetch('/cart/add.js?upcart=1&opens_cart=maybe', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    })
    .then(function(r) { return r.json(); })
    .then(function(response) {
      if (response.status) {
        console.error('Add to cart error:', response.description);
        return;
      }
      // UpCart handles cart slider via the ?upcart=1 query param
      // If UpCart doesn't auto-open, try native cart drawer
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(response);
      }
    })
    .catch(function(err) { console.error('Add to cart failed:', err); })
    .finally(function() {
      if (btn) {
        btn.classList.remove('loading');
        btn.removeAttribute('aria-disabled');
      }
    });
  };

  /* ===== STEPS CAROUSEL (MOBILE) ===== */
  var currentStep = 0;
  window.lpStepNav = function(dir) {
    var cards = document.querySelectorAll('#lpStepsGrid .step-card');
    currentStep = Math.max(0, Math.min(cards.length - 1, currentStep + dir));
    lpStepTo(currentStep);
  };
  window.lpStepTo = function(idx) {
    currentStep = idx;
    var cards = document.querySelectorAll('#lpStepsGrid .step-card');
    cards.forEach(function(c) { c.style.transform = 'translateX(-' + (idx * 100) + '%)'; });
    var dots = document.querySelectorAll('#lpStepsDots .steps-dot');
    dots.forEach(function(d, i) { d.classList.toggle('active', i === idx); });
  };

  /* ===== COMPOUNDS TOGGLE ===== */
  window.lpToggleCompounds = function() {
    var wrap = document.getElementById('lpCompoundsMore');
    var grid = document.getElementById('lpCompoundsSecondary');
    if (!wrap || !grid) return;
    var isOpen = wrap.classList.contains('open');
    if (isOpen) {
      grid.style.maxHeight = '0';
      wrap.classList.remove('open');
    } else {
      grid.style.maxHeight = grid.scrollHeight + 'px';
      wrap.classList.add('open');
    }
  };

  /* ===== PROTOCOL TABS ===== */
  window.lpSwitchProtocol = function(idx) {
    document.querySelectorAll('.lp-colostrum .protocol-tab').forEach(function(t, i) { t.classList.toggle('active', i === idx); });
    document.querySelectorAll('#lpProtocolPanels .protocol-panel').forEach(function(p, i) { p.classList.toggle('active', i === idx); });
  };

  /* ===== COMPARISON TABS (MOBILE) ===== */
  window.lpSwitchComp = function(idx) {
    var cols = document.querySelectorAll('#lpCompCols .comp-col');
    var tabs = document.querySelectorAll('#lpCompTabs .comp-tab');
    cols.forEach(function(c, i) { c.classList.toggle('comp-active', i === idx); });
    tabs.forEach(function(t, i) { t.classList.toggle('active', i === idx); });
  };

  /* ===== FAQ ACCORDIONS ===== */
  window.lpToggleFaq = function(btn) {
    var item = btn.parentElement;
    var answer = item.querySelector('.faq-a, .buybox-faq-a');
    var isOpen = item.classList.contains('open');
    var parent = item.parentElement;
    var items = parent.querySelectorAll('.faq-item, .buybox-faq-item');
    items.forEach(function(fi) {
      fi.classList.remove('open');
      var a = fi.querySelector('.faq-a, .buybox-faq-a');
      if (a) a.style.maxHeight = '0';
    });
    if (!isOpen && answer) {
      item.classList.add('open');
      answer.style.maxHeight = answer.scrollHeight + 'px';
    }
  };

  /* ===== SCIENCE FLIP CARDS ===== */
  window.lpFlipCard = function(el) {
    el.classList.toggle('flipped');
  };

  /* ===== COUNT-UP ANIMATION ===== */
  function initCountUp() {
    var counted = false;
    var observer = new IntersectionObserver(function(entries) {
      if (entries[0].isIntersecting && !counted) {
        counted = true;
        document.querySelectorAll('.lp-colostrum .science-stat[data-count]').forEach(function(el) {
          var target = parseInt(el.dataset.count);
          var suffix = el.dataset.suffix || '';
          var duration = 1500;
          var startTime = null;
          function step(timestamp) {
            if (!startTime) startTime = timestamp;
            var progress = Math.min((timestamp - startTime) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            var current = Math.round(eased * target);
            el.textContent = current.toLocaleString('fr-FR') + suffix;
            if (progress < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        });
      }
    }, { threshold: 0.3 });
    var section = document.querySelector('.lp-colostrum .science-section');
    if (section) observer.observe(section);
  }

  /* ===== STICKY CTA ===== */
  function initStickyCta() {
    var sticky = document.getElementById('lpStickyCta');
    var heroBtn = document.querySelector('.lp-colostrum .hero-cta-btn');
    if (!sticky || !heroBtn) return;
    var hasBeenSeen = false;
    var observer = new IntersectionObserver(function(entries) {
      var entry = entries[0];
      if (entry.isIntersecting) {
        hasBeenSeen = true;
        sticky.classList.remove('visible');
      } else if (hasBeenSeen) {
        sticky.classList.add('visible');
      }
    }, { threshold: 0 });
    observer.observe(heroBtn);
  }

  /* ===== SHIP DATE ===== */
  function initShipDate() {
    var mois = ['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'];
    var now = new Date();
    var parisHour = parseInt(now.toLocaleString('fr-FR', { timeZone: 'Europe/Paris', hour: 'numeric', hour12: false }));
    var parts = now.toLocaleString('fr-FR', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit' }).split('/');
    var d = new Date(parts[2], parts[1] - 1, parts[0]);
    var dayOfWeek = d.getDay();
    var isWeekday = dayOfWeek >= 1 && dayOfWeek <= 5;
    if (!(isWeekday && parisHour < 11)) {
      d.setDate(d.getDate() + 1);
      while (d.getDay() === 0 || d.getDay() === 6) {
        d.setDate(d.getDate() + 1);
      }
    }
    var els = document.querySelectorAll('.lp-colostrum .lp-ship-date');
    els.forEach(function(el) { el.textContent = d.getDate() + ' ' + mois[d.getMonth()]; });
  }

  /* ===== SYNC STICKY WITH DEFAULT SELECTION ===== */
  function initStickySync() {
    var selected = document.querySelector('.lp-colostrum .qty-option.selected');
    if (!selected) return;
    var label = selected.querySelector('.qty-label');
    var price = selected.querySelector('.qty-price');
    var stickyName = document.querySelector('.lp-colostrum .sticky-cta-name');
    var stickyPrice = document.querySelector('.lp-colostrum .sticky-cta-price');
    if (stickyName && label) stickyName.textContent = label.textContent;
    if (stickyPrice && price) stickyPrice.textContent = price.textContent;
  }

  /* ===== INIT ===== */
  document.addEventListener('DOMContentLoaded', function() {
    initReviewRotation();
    initCountUp();
    initStickyCta();
    initShipDate();
    initStickySync();
  });

})();
